module.exports = __webpack_public_path__ + "media/brands/landwind-f7e0c9d6.png";